import { render, staticRenderFns } from "./ProjNav.vue?vue&type=template&id=0eddf06a&lang=pug&"
import script from "./ProjNav.vue?vue&type=script&lang=js&"
export * from "./ProjNav.vue?vue&type=script&lang=js&"
import style0 from "./ProjNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports